import { useState } from "react";
import axios from "axios";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Lock, ArrowLeft, ShieldCheck } from "lucide-react";
import { API_BASE_URL } from "../config";
import vrmLogo from "../assets/VRM_New.jpeg";

function BuyerResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!token) {
      setError("This password reset link is invalid or missing.");
      return;
    }

    if (password.length < 8) {
      setError("Password must be at least 8 characters long.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${API_BASE_URL}/api/buyer/auth/reset-password`,
        { token, password }
      );

      setMessage(res.data.message || "Password reset successfully.");
      setPassword("");
      setConfirmPassword("");

      setTimeout(() => navigate("/buyer/login"), 1800);
    } catch (err) {
      setError(
        err.response?.data?.message ||
        "Unable to reset your password. The link may have expired."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px", fontFamily: "Inter, sans-serif" }}>
      <div style={{ background: "#fff", borderRadius: "16px", padding: "40px", width: "100%", maxWidth: "420px", boxShadow: "0 25px 50px -12px rgba(0,0,0,.3)", boxSizing: "border-box" }}>
        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <img src={vrmLogo} alt="VRM AI Logo" style={{ height: "64px", marginBottom: "12px", mixBlendMode: "darken" }} />
          <h2 style={{ margin: "0 0 8px", color: "#0f172a", fontSize: "22px" }}>VRM AI TECHNOLOGY</h2>
          <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "#eef2ff", color: "#4f46e5", padding: "4px 12px", borderRadius: "20px", fontSize: "12px", fontWeight: 600 }}>
            <ShieldCheck size={14} /> Buyer Portal
          </div>
        </div>

        <h3 style={{ color: "#0f172a", marginBottom: "8px" }}>Set a New Password</h3>
        <p style={{ color: "#64748b", fontSize: "14px", lineHeight: 1.6, marginBottom: "24px" }}>
          Choose a new password with at least 8 characters.
        </p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="new-password" style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#475569", marginBottom: "6px" }}>New Password</label>
          <div style={{ position: "relative", marginBottom: "18px" }}>
            <Lock size={18} style={{ position: "absolute", left: "14px", top: "12px", color: "#94a3b8" }} />
            <input id="new-password" type="password" required minLength={8} autoComplete="new-password" placeholder="At least 8 characters" value={password} onChange={(e) => setPassword(e.target.value)} style={{ width: "100%", padding: "10px 14px 10px 42px", borderRadius: "8px", border: "1px solid #cbd5e1", fontSize: "14px", outline: "none", boxSizing: "border-box" }} />
          </div>

          <label htmlFor="confirm-password" style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#475569", marginBottom: "6px" }}>Confirm New Password</label>
          <div style={{ position: "relative", marginBottom: "18px" }}>
            <Lock size={18} style={{ position: "absolute", left: "14px", top: "12px", color: "#94a3b8" }} />
            <input id="confirm-password" type="password" required minLength={8} autoComplete="new-password" placeholder="Re-enter your password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} style={{ width: "100%", padding: "10px 14px 10px 42px", borderRadius: "8px", border: "1px solid #cbd5e1", fontSize: "14px", outline: "none", boxSizing: "border-box" }} />
          </div>

          {error && <div role="alert" style={{ background: "#fef2f2", color: "#991b1b", padding: "10px 14px", borderRadius: "8px", fontSize: "13px", marginBottom: "18px" }}>{error}</div>}
          {message && <div role="status" style={{ background: "#ecfdf5", color: "#065f46", padding: "10px 14px", borderRadius: "8px", fontSize: "13px", marginBottom: "18px" }}>{message}</div>}

          <button type="submit" disabled={loading || !token} style={{ width: "100%", padding: "12px", background: "#4f46e5", color: "#fff", border: "none", borderRadius: "8px", fontWeight: 600, fontSize: "15px", cursor: loading ? "not-allowed" : "pointer" }}>
            {loading ? "Updating password…" : "Reset Password"}
          </button>
        </form>

        <div style={{ marginTop: "24px", textAlign: "center" }}>
          <Link to="/buyer/login" style={{ color: "#4f46e5", textDecoration: "none", fontSize: "13px", fontWeight: 600, display: "inline-flex", alignItems: "center", gap: "6px" }}>
            <ArrowLeft size={15} /> Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default BuyerResetPassword;
